import React from 'react';
import { Chip, Typography } from '@material-ui/core';

/**
 * Status chip tones match backend enums:
 * - Ingest: `trunk/DB/FBM/FBMPartnerOrderIngestStatusEnum.php` (PENDING, SUCCEEDED, FAILED, DEFERRED, CANCELLED).
 * - Acknowledgment: `trunk/DB/FBM/FBMPartnerOrderAcknowledgmentStatusEnum.php` (NONE, ACCEPTED).
 */
const CHIP_TONE_STYLES = {
    error: { borderColor: '#c62828', color: '#b71c1c', backgroundColor: '#ffebee' },
    neutral: {},
    success: { borderColor: '#2e7d32', color: '#1b5e20', backgroundColor: '#e8f5e9' },
    warning: { borderColor: '#f57c00', color: '#e65100', backgroundColor: '#fff3e0' },
};

function partnerEnumChipTone(kind, normalized) {
    if (kind === 'ingest') {
        if (normalized === 'SUCCEEDED') {
            return 'success';
        }
        if (normalized === 'FAILED' || normalized === 'CANCELLED') {
            return 'error';
        }
        if (normalized === 'PENDING' || normalized === 'DEFERRED') {
            return 'warning';
        }
        return 'neutral';
    }
    if (kind === 'acknowledgment') {
        if (normalized === 'ACCEPTED') {
            return 'success';
        }
        if (normalized === 'NONE') {
            return 'warning';
        }
        return 'neutral';
    }
    return 'neutral';
}

function FBMPartnerOrderStatusChip({ kind, value }) {
    if (value === null || value === undefined || value === '') {
        return (
            <Typography variant="subtitle1" component="span" color="textSecondary">
                —
            </Typography>
        );
    }
    const labelText = String(value);
    const normalized = labelText.toUpperCase();
    const tone = partnerEnumChipTone(kind, normalized);
    const toneStyle = CHIP_TONE_STYLES[tone];
    const chipStyle = { fontWeight: 600, ...toneStyle };

    return (
        <Chip
            data-testid="fbm-partner-order-status-chip"
            data-tone={tone}
            label={labelText}
            size="small"
            variant="outlined"
            style={chipStyle}
        />
    );
}

export { FBMPartnerOrderStatusChip };
